import type { StateCreator } from "zustand";
import { tmp } from "../tmpIds";
import { DEFAULT_BASIC, type DraftStoreState } from "./types";

type MachinesActions = Pick<
  DraftStoreState,
  "addMachine" | "cancelPendingMachine" | "removeMachine" | "updateMachineBasic"
>;

export const createMachinesSlice: StateCreator<DraftStoreState, [], [], MachinesActions> = (
  set
) => ({
  addMachine: (basic = {}, position = { x: 200, y: 200 }) => {
    const tmpMachineId = tmp.machine();
    const tmpNodeId = tmp.node();
    set((state) => ({
      machines: {
        ...state.machines,
        [tmpMachineId]: {
          tmpId: tmpMachineId,
          basic: { ...DEFAULT_BASIC, ...basic },
          parameters: [],
          sensorLinks: [],
          compatibilities: [],
        },
      },
      canvas: {
        ...state.canvas,
        nodes: [
          ...state.canvas.nodes,
          {
            tmpId: tmpNodeId,
            type: "MACHINE",
            label: basic.name ?? "Nova máquina",
            x: position.x,
            y: position.y,
            machineTmpId: tmpMachineId,
            data: {},
          },
        ],
      },
      dirty: true,
    }));
    return tmpMachineId;
  },

  cancelPendingMachine: (tmpMachineId) => {
    set((state) => {
      const { [tmpMachineId]: _, ...restMachines } = state.machines;
      void _;
      return {
        machines: restMachines,
        canvas: {
          ...state.canvas,
          nodes: state.canvas.nodes.filter((n) => n.machineTmpId !== tmpMachineId),
        },
        dirty: true,
      };
    });
  },

  removeMachine: (tmpMachineId) => {
    set((state) => {
      const { [tmpMachineId]: _, ...restMachines } = state.machines;
      void _;
      const removedNode = state.canvas.nodes.find((n) => n.machineTmpId === tmpMachineId);
      const newNodes = state.canvas.nodes.filter((n) => n.machineTmpId !== tmpMachineId);
      const newEdges = removedNode
        ? state.canvas.edges.filter(
            (e) =>
              e.sourceNodeTmpId !== removedNode.tmpId && e.targetNodeTmpId !== removedNode.tmpId
          )
        : state.canvas.edges;
      return {
        machines: restMachines,
        canvas: { nodes: newNodes, edges: newEdges },
        dirty: true,
      };
    });
  },

  updateMachineBasic: (tmpMachineId, patch) => {
    set((state) => {
      const m = state.machines[tmpMachineId];
      if (!m) return state;
      return {
        machines: {
          ...state.machines,
          [tmpMachineId]: { ...m, basic: { ...m.basic, ...patch } },
        },
        canvas: {
          ...state.canvas,
          nodes: state.canvas.nodes.map((n) =>
            n.machineTmpId === tmpMachineId && patch.name ? { ...n, label: patch.name } : n
          ),
        },
        dirty: true,
      };
    });
  },
});
